export default "__VITE_ASSET__DEs1FNZO__"